import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-merchantusermanagepermissions',
  templateUrl: './managepermissions.component.html',
  styleUrls: ['./managepermissions.component.css']
})
export class MerchantusermanagepermissionsComponent extends EchexbaseComponent implements OnInit {
	public permissionList :{};
	public userToken :string;
	public token :string;
	public merchant_id :string;
	public merchantUserRole :string;
	public role_id: string;
	busy:Subscription;
	public userPermissionList: {};
	
	
	constructor(protected echexpaymentService: EchexpaymentService, protected router: Router,  protected toastr: ToastrService, protected  route: ActivatedRoute, protected userService: UserService, protected localStorageService: LocalstorageService){
	super(route, router, toastr, userService, echexpaymentService, localStorageService);
		this.router = router;
		let userDetails = <any>{};
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		userDetails = this.localStorageService.getData("currentUser");
		// this.merchantUserRole =  userDetails.role_id;
		// this.merchant_id =  userDetails._id;
		this.role_id = userDetails.role_id;
	}

	public user_permissions = [
		// { value: 'ViewCheck', display: 'View Cheque' }, 
		{ value: 'PrintCheck', display: 'Print Check' },
		{ value: 'CreateCheque', display: 'Create Check' },
		{ value: 'Dashboard', display: 'Dashboard' },
		{ value: 'Profile', display: 'Profile' },
		{ value: 'Transactions', display: 'Transactions' }  
	];

	ngOnInit() {
		this.getUserPermissionById();
	}

	goBack() {
		this.router.navigate(['/profile']);
	}
	// get merchant user token
	// getUserToken(){
	// 	let params: any = this.route.snapshot.params;
	// 	let data = {
	// 	  user_token:this.token,
	// 	  token:params.id,
	// 	  id:params.id,
	// 	}
	// 	let responseData = <any>{};
	// 	this.busy = this.echexpaymentService.ghostEnable(data).subscribe(
	// 	   response => {
	// 	   responseData = response;
	// 	   this.userToken =  responseData.data;
	// 	   this.getEachUserPermission();
	// 	   },
	// 	   error => {
	// 		 responseData = error;
	// 		 this.toastr.error(responseData.error.message, 'Failed!');
	// 	   }
	// 	);
	// }
	// get merchant permission
	getUserPermissionById() {
		let params: any = this.route.snapshot.params;
		let data = {
		  token:params.id,
		  user_token:this.token,
		  id:params.id
		}
		
		let responseData = <any>{};
		this.busy = this.userService.getUserPermissionByIdAPI(data).subscribe(
		   response => {
		    responseData = response;
			this.permissionList = {
				Dashboard: 'yes',
				...responseData.data.settings.permissions
			  };
			
		   },
		   error => {
		     responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}
	// Get merchat user permission
	getEachUserPermission() {
		let params: any = this.route.snapshot.params;
		let user_token: any = this.userToken;
		let data = {
			user_token: user_token.user_token,
			token:params.id,
			id:params.id,
			role_id:4
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getEachUserPermission(data).subscribe(
		   response => {
		    responseData = response;
			var permissionArray = new Array(); 
			var i = 0;
			var obj = responseData.data.settings.permissions;
			var usersJson: any[] = Array.of(responseData.data.settings.permissions);
			this.userPermissionList = usersJson;
			//this.getMerchantPermission();
			
		   },
		   error => {
		     responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}


}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/managepermissions/merchantusermanagepermissions.component.ts